import { useState, useEffect } from "react";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";

import styled from "styled-components";
import { Tabs } from "antd";

import { getBoardListWithRootCategory } from "../../api/categoryAPI";

import { GeneralTypeItem, ConsultationItem } from "./GeneralType";
import CaseConference from "./CaseConference";

const BoardTab = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [boardList, setBoardList] = useState<any[]>([]);
  const [activeBoard, setActiveBoard] = useState<string>(searchParams.get("board") || "0");

  useEffect(() => {
    getBoardListWithRootCategory().then((data) => {
      const tabItems: any[] = [];

      for (const board of data) {
        let childrenContent;

        switch (board.categoryType) {
          case "GENERAL":
            childrenContent = <GeneralTypeItem rootCategoryId={board.rootCategories[0]?.id} />;
            break;
          case "PATHOLOGY_PRACTICE":
            childrenContent = <ConsultationItem rootCategoryId={board.rootCategories[0]?.id} />;
            break;
          case "CONFERENCE":
            continue; //집담회 카테고리 편집 기능 없음
            childrenContent = <CaseConference rootCategoryId={board.rootCategories[0]?.id} />;
            break;
          default:
            childrenContent = <div>준비중입니다.</div>;
            break;
        }

        const tabItem = {
          key: (board.board_id - 1).toString(),
          label: board.name,
          children: childrenContent,
        };
        tabItems.push(tabItem);
      }
      setBoardList(tabItems);

      if (searchParams.get("board") === null) {
        const firstBoard = tabItems[0];
        setSearchParams({ board: "0", boardName: firstBoard?.label || "" }, { replace: true });
      } else if (!searchParams.get("boardName")) {
        const currentBoard = searchParams.get("board");
        const selectedBoard = tabItems.find(b => b.key === currentBoard);
        if (selectedBoard) {
          const newParams = new URLSearchParams(searchParams);
          newParams.set("boardName", selectedBoard.label);
          setSearchParams(newParams, { replace: true });
        }
      }
    });
  }, []);

  useEffect(() => {
    const board = searchParams.get("board") || "0";
    setActiveBoard(board);
  }, [searchParams]);

  const handleBoardChange = (newBoard: any) => {
    const selectedBoard = boardList.find(b => b.key === newBoard);
    const newParams: any = { board: newBoard };
    if (selectedBoard?.label) {
      newParams.boardName = selectedBoard.label;
    }
    setSearchParams(newParams, { replace: true });
  };

  return (
    <>
      <Tabs
        activeKey={activeBoard}
        items={boardList}
        onChange={handleBoardChange}
        destroyInactiveTabPane={true}
      />
    </>
  );
};

export default BoardTab;